<template>
  <transition name="toast">
    <div
      v-if="toastMessage"
      class="toast-message"
      role="alert"
      aria-live="assertive"
    >
      <div class="toast-message__popup" @click.self="removeToastMessage">
        <p class="toast-message__text">
          {{ toastMessage }}
        </p>
      </div>
    </div>
  </transition>
</template>

<script>
  import { mapState } from 'vuex'

  const TIMEOUT_DURATION = 3000

  export default {
    data() {
      return {
        activeTimeout: null,
      }
    },
    computed: {
      ...mapState({
        toastMessage: state => state.toast.toastMessage,
      }),
    },
    watch: {
      toastMessage() {
        clearTimeout(this.activeTimeout)
        if (this.toastMessage) {
          this.activeTimeout = setTimeout(() => {
            this.removeToastMessage()
          }, TIMEOUT_DURATION)
        }
      },
    },
    methods: {
      removeToastMessage() {
        this.$emit('remove-toast-message')
      },
    },
  }
</script>

<style lang="scss" src="./ToastMessage.scss"></style>
